import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { alertRef } from '../../../App';
import { Button, Textarea } from '../../../Components/StyledComponents';
import { convertCost } from '../../../Utils/functions';
import './Coupon.scss';

/* ***
../Point/Point.js 참고
*** */

const Coupon = ({info,getInfo}) =>  {
    const [ list, setList ] = React.useState([])
    const [ memo, setMemo ] = React.useState('')
    const [ isModify, setIsModify ] = React.useState(false)

    React.useEffect(() => {
        if(typeof info.UserInfo !== 'undefined'){
            setMemo(info.Memo)
            axios.get('/api/customer/info/coupon/' + info.UserInfo._id.$oid )
            .then((data) => {
                if(Object.keys(data.data).length > 0) setList(data.data.History)
            })
        }
    },[info])

    const handleSaveBtn = () => {
        if(!isModify){
            setIsModify(true)
            setTimeout(() => {
                document.getElementById('input-memo').focus()
            }, 10);
        }else {
            saveMemo()
        }
    }

    const saveMemo = () => {
        axios.post('/api/customer/info/memo/' + info.UserInfo._id.$oid,{ Memo : memo })
        .then((data) => {
            if(data.status === 204){
                alertRef.current.showAlert({ title : `메모가 수정되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();setIsModify(false);getInfo()} })
            }
        })
    }

    return (
        <div className='user-coupon'>
            <div className='edit-btn-row'>
                <Button variant={ isModify ? 'main' : 'sub'} small style={{ width : 88, alignSelf : 'flex-end', marginBottom : 16 }} onClick={() => handleSaveBtn()}>
                    { isModify ? '저장하기' : '수정하기'}
                </Button>
            </div>
            <div className='row between'>
                <div className='row'>
                    <div className='user-icon-box'>
                        <img src={require('../../../aseets/icons/user.svg').default} style={{ width : 56, height : 56 }} />
                    </div>
                    <div>
                        <p className='user-tel'>{info.UserInfo.Tel} 님</p>
                        <p className='user-date'>{moment(info.RegDate.$date).utc().format('YYYY.MM.DD')} 가입</p>
                    </div>
                </div>

                <div className='row between' style={{ alignItems : 'flex-start'}}>
                    <Textarea
                        id="input-memo"
                        value={memo}
                        onChange={(e) => setMemo(e.target.value)}
                        placeholder='고객에 대해 간단하게 메모 해주세요.'
                        style={{ width : 540, height : 80, paddingTop : 8 }}
                        disabled={!isModify}
                    />
                </div>
            </div>

            <div className='user-info-box'>
            <div className='info'>
                    <p className='info-title'>적립 횟수</p>
                    <p className='info-text'>{convertCost(info.PointCount)}회</p>
                </div>
                <div className='info'>
                    <p className='info-title'>보유 포인트</p>
                    <p className='info-text' style={{ color : '#f95f53', textDecorationLine : 'underline'}}>{convertCost(info.Point)}P</p>
                </div>
                <div className='info'>
                    <p className='info-title'>보유 쿠폰</p>
                    <p className='info-text'>{info.CouponCount}장</p>
                </div>
                <div className='info' style={{ borderRightWidth : 0 }}>
                    <p className='info-title'>사용 쿠폰</p>
                    <p className='info-text'>{info.UseCouponCount}장</p>
                </div>
            </div>

            <div className='row between'>
                <p className="sub-title">최근 쿠폰 사용 내역</p>
                <Button disabled variant='sub' style={{ paddingLeft : 16, paddingRight : 16, paddingTop : 8, paddingBottom : 8 }}>
                    총 {convertCost(list.length)}건
                </Button>
            </div>

            <table>
                <tbody>
                    <tr>
                        <th style={{ width : 320 }}>사용일시</th>
                        <th style={{ width : 210 }}>쿠폰명</th>
                        <th style={{ width : 410  }}>혜택</th>
                    </tr>
                    {
                        list.map((data,i) => {
                            return (
                                <tr key={i}>
                                    <td style={{ width : 320}}>{moment(data.Date.$date).utc().format('YY-MM-DD(dd) HH:mm:ss')}</td>
                                    <td style={{ color : '#3f3f3f', width : 210}}>{data.Coupon.Name}</td>
                                    <td style={{ width : 410, whiteSpace : 'nowrap', overflow : 'hidden', textOverflow : 'ellipsis' }}>{data.Coupon.Description}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default Coupon;